import treeService from '../service/tree';
import vibrationAnalyzeReportService from '../service/vibrationAnalyzeReport';
const parseTree = require('../util/parseTree');
const state = {
    activeTags: [],
    activePoints: [],
    checkedNodes: [],
    selectedNode: '',
    tree: [],
    paths: [],
    status: {
        loading: false
    },
    config: {
        showCheckbox: true
    }
};

const actions = {
    updateSelectedNode({ commit }, node) {
        commit('setSelectedNode', node);
    },
    updateConfig({ commit }, config) {
        commit('updateConfig', config);
    },
    decreaseUnansweredEvaluation({ commit }, pointId) {
        commit('decreaseUnansweredEvaluation', pointId);
    },
    updateCheckedNodes({ commit }, nodes) {
        commit('setCheckedNodes', nodes);
    },
    updatePaths({ commit }, paths) {
        commit('setPaths', paths);
    },
    updateActiveTags({ commit }, tags) {
        commit('setActiveTags', tags);
    },
    updateActivePoints({ commit }, points) {
        commit('setActivePoints', points);
    },
    getTree({ commit }) {
        let tree = [];
        commit('setLoading', true);
        Promise.allSettled([treeService.getTree(), vibrationAnalyzeReportService.getUnansweredEvaluationsCount()])
            .then(([treeResult, unansweredEvaluationsCountsResult]) => {
                let tree = [];
                let unansweredEvaluationsCounts = [];
                console.log("treeResult",treeResult);
                if (treeResult.status == "fulfilled") {
                    tree = treeResult.value;
                }
                if (unansweredEvaluationsCountsResult.status == "fulfilled") {
                    unansweredEvaluationsCounts = unansweredEvaluationsCountsResult.value;
                }

                this.tree = tree;
                unansweredEvaluationsCounts.forEach(x => {
                    let index = this.tree.findIndex(y => y._id == x.point);
                    if (index != -1) {
                        this.tree[index].unansweredEvaluationsCount = x.unansweredEvaluationsCount;
                    }
                });
                commit('setFlatTree', this.tree);
                this.tree = tree.sort(function (a, b) {
                    var aParent = `${a.parent}`.toUpperCase();
                    var bParent = `${b.parent}`.toUpperCase();
                    var aName = `${a.name}`.toUpperCase();
                    var bName = `${b.name}`.toUpperCase();
                    if (aParent == bParent) {
                        return (aName < bName) ? -1 : (aName > bName) ? 1 : 0;
                    }
                    else {
                        return (aParent < bParent) ? -1 : 1;
                    }
                });
                var superNode = { "_id": "root", "name": "", "nodeType": "group", "tagCode": "", "parent": null };
                this.tree.filter(x => x.parent == null).forEach(x => x.parent = 'root');
                this.tree.push(superNode);
                commit('setTree', parseTree(this.tree));
            });
    },
    moveNodes({ commit }, changesOfNodes) {
        commit('setLoading', true);
        treeService.moveNodes(changesOfNodes).then(() => {
            commit('setLoading', false);
        }).catch((e) => {
            console.log(e);
            commit('setLoading', false);
        });
    }

};
const mutations = {
    setSelectedNode(state, node) {
        state.selectedNode = node;
    },
    setCheckedNodes(state, nodes) {
        state.checkedNodes = nodes;
    },
    updateConfig(state, config) {
        Object.assign(state.config, config);
    },
    setPaths(state, paths) {
        state.paths = paths;
    },
    setLoading(state, loading) {
        state.status.loading = loading;
    },
    setFlatTree(state, tree) {
        state.flatTree = tree;
    },
    setTree(state, tree) {
        state.tree = tree;
        state.status.loading = false;
    },
    setActiveTags(state, tags) {
        state.activeTags = tags;
    },
    decreaseUnansweredEvaluation(state, pointId) {
        let pointIndex = state.flatTree.findIndex(x => x._id == pointId);
        // console.log(pointIndex);
        if (pointIndex != -1) {
            // console.log(state.flatTree[pointIndex]);
            state.flatTree[pointIndex].unansweredEvaluationsCount--;
        }
    },
    setActivePoints(state, points) {
        state.activePoints = points;
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};



